<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Survey',
    path: '/survey',
    active: true
}]"></app-breadcrumb>
<app-page-header title="Surveys" [buttons]="[{
        name: 'Add',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]" (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<app-slide-panel title="{{ this.editSelected ? 'Edit' : 'Add' }}" [(visible)]="panelVisible" *ngIf="panelVisible">
    <app-survey-add-edit [survey]="editSelected" (onDone)="onPopupclose()"></app-survey-add-edit>
</app-slide-panel>